import React from "react";
import Work from "../../templates/content-types/work";
import data from "../../page-data/work/fiserv-dashboard-data";

const Post = ({location}) => {
  return <Work {...data} location={location} />;
};

export default Post;
